import { MicButton } from "../MicButton";

/**
 * 事前チェックのうち、**AI が読み上げるだけで人の操作を待たない step** の画面
 * (spec 2026-08-04 D14 / D15)。遊び方チュートリアルと完了案内が共有し、本編前半
 * (`VoiceStage`) とまったく同じ「マイク 1 つ」を出す。
 *
 * **共有するのは、step の境目でも本編に入る瞬間でも画面が 1 ドットも動かないことを
 * 構造的に守るため** — 同じ JSX を 2 箇所に書くと、片方のマイクのサイズや state を
 * 変えたときにもう片方がずれ、「今のは何だったのか」を目で追わせてしまう。
 * 画面を見ないで済ませるという目的そのものを損なう。
 *
 * - **state は `ai-speaking` 固定** — `listening` (緑) は「あなたの番」の合図なので、
 *   聴取の無いこれらの step で出すと案内の途中で話し始めてしまう。
 * - **タップは noop** — 本編でも読み上げ中のタップは `continuous.start()` の冪等な
 *   noop なので、見た目だけでなく押したときの挙動まで本編と同じになる。送りの
 *   アクセラレータには使わない: 「マイクを押すと次へ進む」は本編で成り立たない操作。
 * - **`disabled` にはしない** — 灰色になって本編の見た目と変わってしまい、下見にならない。
 *
 * `testId` を受けるのは、どの step に居るかをテストと E2E が名指しできるようにするため
 * (画面が同一なので、マイクの有無では 2 つを区別できない)。
 */
export function PreflightStage({ testId }: { testId: string }) {
  return (
    <div
      data-testid={testId}
      className="flex-1 min-h-0 flex flex-col items-center justify-center py-8"
    >
      <MicButton state="ai-speaking" onStart={() => undefined} size="lg" ariaLabel="マイク" />
    </div>
  );
}
